export default __webpack_public_path__ + "static/media/news47.f412cd2f.jpg";